import { StripeElementType } from '@stripe/stripe-js';

export const getEmptyStripeFieldError = (elementType: StripeElementType) => ({
  ErrorCode: 'FieldIsRequired',
  PropertyName: elementType,
  InternalError: true,
});
